import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=228c42fe&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=228c42fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c42fe",
  null
  
)

export default component.exports